import React from "react";
import { Form, Button, Row, Col, Card, Image } from "antd";
import { MailOutlined } from "@ant-design/icons";
import AdnInput from "../../common/adnInput/AdnInput";
import { AdnValidationAdentisEmail } from "../LoginValidations";
import AdnLogo from "../../../assets/images/adentis-novo-logo-branco-horizontal.svg";
import AdnLoginBg from "../../../assets/images/adentis-login-bg.jpg";
import "./../LoginForm.css";

function ForgotPageForm({ handleForgot, form, loading }) {
  return (
    <div className="login-container">
      <Row className="login-row">
        <Col xs={0} sm={6} md={12} lg={14} xl={16} className="login-image-col">
          <Image src={AdnLoginBg} preview={false} className="login-image" />
          <Image src={AdnLogo} preview={false} wrapperClassName="login-logo" />
        </Col>
        <Col xs={24} sm={18} md={12} lg={10} xl={8} className="login-form-col">
          <Form
            name="normal_login"
            className="login-form"
            layout="vertical"
            initialValues={{
              remember: true,
            }}
            form={form}
            onFinish={handleForgot}
          >
            <h1>Forgot Password</h1>
            <AdnInput
              prefix={<MailOutlined className="site-form-item-icon" />}
              type="email"
              placeholder="Email"
              name="email"
              rules={AdnValidationAdentisEmail}
              maxLength="50"
              validateTrigger="onSubmit"
            />
            <Form.Item style={{ marginLeft: "auto", marginRight: "auto" }}>
              <Button
                type="primary"
                htmlType="submit"
                className="login-form-button"
                loading={loading}
              >
                Send Email
              </Button>
            </Form.Item>
            <Form.Item>
              <a className="login-form-forgot" href="/login">
                Back
              </a>
            </Form.Item>
          </Form>
        </Col>
      </Row>
    </div>
  );
}

export default ForgotPageForm;
